import ShortenedText from './ShortenedText'

export default ShortenedText
